<template>
  <div class="mt-10 px-2 pb-20 lg:pb-36">
    <article class="mx-auto max-w-article-container">
      <slot />
    </article>
  </div>
</template>
